import { BASIC_MAP } from '@/config/routerMap';

const permission = {
  state: {
    routers: BASIC_MAP,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = BASIC_MAP.concat(routers);
    },
  },
};

export default permission;
